import { Component, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core'

@Component({
  styles: [`
    @media only screen and (max-width: 848px) {
      @media only screen and (min-width: 768px) {
        :host(.keyword-form) .pieces-input {
          width: 6rem !important;
        }
        .pieces-input {
          width: 100% !important;
        }
      }
    }
    .inputs > button {
      touch-actions: manipulation;
    }
    .pieces-input {
      width: 6rem;
      font-size: 1.25rem;
      line-height: 1.25rem;
      border-radius: 4px;
      padding: 10px 16px;
      font-family: Lato;
      font-style: normal;
      font-weight: normal;
      border: 2px solid #aaa;
      margin-left: 1.375rem;
    }
    :host(.keyword-form) .pieces-input {
      font-size: 1rem;
      line-height: 1rem;
      border-radius: 4px;
      padding: 7px 12px;
      margin-left: 0;
    }
    :host(.keyword-form) .qty-wrapper{
      line-height: 1rem;
      justify-content: left !important;
    }
    .pieces-input::-webkit-outer-spin-button,
    .pieces-input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    .control {
      line-height: inherit;
      padding-left: .375rem;
    }
  `],
  selector: 'quantity-selector',
  template: `
    <div class="d-flex flex-row justify-content-center qty-wrapper">
      <input
        data-ls-enabled="true"
        class="pieces-input"
        [(ngModel)]="quantity"
        (ngModelChange)="handleQuantityChange($event)"
        #quantityInput
      />
      <div class="d-flex flex-column">
        <i class="fas fa-chevron-up text-primary cursor-pointer control" (click)="inc()"></i>
        <i class="fas fa-chevron-down text-primary cursor-pointer control" (click)="dec()"></i>
      </div>
    </div>
`
})
export class QuantitySelectorComponent {

  @Input() min: number = 0
  @Input() max: number = 999
  @Input() set quantity(value: number) {
    this._quantity = value
    this.handleQuantityChange(value)
  }
  get quantity(): number {
    return this._quantity
  }

  @Output() quantityChange = new EventEmitter<number>();
  @ViewChild('quantityInput') quantityInput!: ElementRef

  _quantity: number = 0

  constructor(private cdRef:ChangeDetectorRef) {}

  handleQuantityChange(value = null) {
    this._quantity = -1
    this.cdRef.detectChanges()
    this._quantity = parseInt(value)
    if (this._quantity > this.max) this._quantity = this.max
    if (this._quantity < this.min || isNaN(this._quantity)) this._quantity = this.min
    this.cdRef.detectChanges()
    this.quantityChange.emit(this._quantity)
  }

  inc() {
    if (!this._quantity) this._quantity = 0
    this.handleQuantityChange(++this._quantity)
  }

  dec() {
    if (!this._quantity) this._quantity = 0
    this.handleQuantityChange(--this._quantity)
  }

  click() {
    this.quantityInput.nativeElement.focus()
  }
}
